var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocWarnFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7344 8.37305C11.7345 9.65856 12.3374 10.2715 13.623 10.2715H20.8955V19.3916C20.8955 21.4809 19.8605 22.5361 17.7812 22.5361H7.11426C5.04507 22.5361 4 21.491 4 19.3916V4.1543C4 2.06501 5.04507 1 7.11426 1H11.7344V8.37305ZM12.5 19.6133C12.0858 19.6133 11.75 19.9491 11.75 20.3633V20.5C11.75 20.9142 12.0858 21.25 12.5 21.25C12.9142 21.25 13.25 20.9142 13.25 20.5V20.3633C13.25 19.9491 12.9142 19.6133 12.5 19.6133ZM12.5 12C12.0858 12 11.75 12.3358 11.75 12.75V18C11.75 18.4142 12.0858 18.75 12.5 18.75C12.9142 18.75 13.25 18.4142 13.25 18V12.75C13.25 12.3358 12.9142 12 12.5 12ZM13.1006 1.11035C13.5224 1.18072 13.9443 1.47209 14.4062 1.9541L19.9512 7.58887C20.4233 8.08104 20.7139 8.48365 20.7842 8.89551H13.6533C13.2917 8.89551 13.1006 8.71412 13.1006 8.35254V1.11035Z",
    fill: "#6130B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocWarnFilled);
export default __webpack_public_path__ + "static/media/doc-warn-filled.e07e7aa7fb8b5948f0091ce55e1fd252.svg";
export { ForwardRef as ReactComponent };